import { render, staticRenderFns } from "./NewEducationProgramsDialog.vue?vue&type=template&id=33518562"
import script from "./NewEducationProgramsDialog.vue?vue&type=script&lang=js"
export * from "./NewEducationProgramsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports